import {check_street_number, check_postal_code} from './remote_checks';
import {isEUCountry} from './insured_shipping'

document.addEventListener('DOMContentLoaded', function () {
  
  const show_label = $('#show_label').val()
  const hide_label = $('#hide_label').val()
  
  function hide_pk_addr() {
    $('.pk-required').removeAttr('required')
    $('.admin-validate').validator('destroy')
    $('#update_pk_address').val(false)
    $('#show_hide_pk_address').text(show_label)
    $('.company-required-b').removeAttr('required')
    $('.company-required-c').removeAttr('required')
    
  }
  
  function show_pk_address() {
    $('.pk-required').prop('required', true)
    $('.admin-validate').validator()
    $('#update_pk_address').val(true)
    $('#show_hide_pk_address').text(hide_label)
    set_required_fields();
  }
  
  function show_hide_pickup_address() {
    const element = '#admin-pickup-address'
    
    $(element).toggle()
    toggle_admin_pickup_address($('#user_role').val());
    if ($(element).is(':visible')) {
      show_pk_address()
    } else {
      hide_pk_addr()
    }
    
  }
  
  const enable_pec_face = (value, force_hide = false) => {
    const face_pec = $('#face_pec');
    const face_pec_container = $('#face_pec_container');
    if (value === 'R' || force_hide) {
      face_pec.removeAttr('required');
      face_pec_container.hide();
    } else {
      face_pec.prop('required', true);
      face_pec_container.show();
      
    }
    
  }
  
  const reset_focus = ($el) => {
    // a trick to activate validator on $el
    const $focused = $(':focus');
    $el.focus();
    $focused.focus();
  }
  
  const enable_vat = () => {
    const $vat_code = $('#billing_address_vat')
    $vat_code.prop('required', true);
    $vat_code.prop('maxlength', 16);
    reset_focus($vat_code);
    $('#billing_address_check_vat').val(true)
    $('#it-mandatory-vat').show();
  }
  $('#pickup_address_company_name').keypress(function (event) {
    
    if (event.key === 'Enter') {
      event.preventDefault();
      return false;
    }
  });
  
  
  const disable_vat = () => {
    const $vat_code = $('#billing_address_vat')
    $vat_code.removeAttr('required');
    $vat_code.prop('maxlength', 31);
    reset_focus($vat_code);
    $('#billing_address_check_vat').val(false)
    $('#it-mandatory-vat').hide();
    
  }
  
  
  const vat_address = () => {
    if ($('#billing_address_use_it').prop('checked')) {
      return ($('#bill_delivery_address_location_type').val() === 'R' &&
        $('#bill_pk_address_country_code').val() === 'IT')
      
    } else {
      return ($('#pickup_address_location_type').val() === 'R' &&
        $('#pickup_address_country_code').val() === 'IT')
      
    }
  }
  const reset_vat_icon = ($vat_code_icon) => {
    $vat_code_icon.attr("class", "fa fa-percent");
    $vat_code_icon.css('color', 'green');
    remove_error_from_group($('#vat-group'));
    $('#cf-errors').text('');
    $(':input[type="submit"]').prop('disabled', false);
    
  }
  
  const add_error_to_group = ($el) => {
    
    $el.addClass('has-error has-danger');
    
  }
  const add_error_to_vat = () => {
    add_error_to_group($('#vat-group'));
    $('#cf-errors').text($('#cf-error-text').val());
    $(':input[type="submit"]').prop('disabled', true);
    
  }
  const remove_error_from_group = ($vat_group) => {
    $vat_group.removeClass('has-error has-danger');
    
  }
  
  const controllaCF = function ($el) {
    const $vat_code_icon = $('#vat_code_icon')
    if (($el).val() === undefined) return;
    
    if (!vat_address()) {
      reset_vat_icon($vat_code_icon)
      return;
    }
    
    // Definisco un pattern per il confronto
    const pattern = /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/;
    if (($el).val().length === 0) {
      reset_vat_icon($vat_code_icon)
    } else {
      if ($el.val().search(pattern) === -1) {
        $vat_code_icon.attr("class", "fa fa-exclamation-circle");
        $vat_code_icon.css('color', 'red');
        add_error_to_vat();
        console.log("Il valore inserito non è un codice fiscale!");
      } else {
        $vat_code_icon.attr("class", "fa fa-check-circle");
        $vat_code_icon.css('color', 'green');
        remove_error_from_group($('#vat-group'));
        $('#cf-errors').text('');
        $(':input[type="submit"]').prop('disabled', false);
        
        console.log("ok!");
        
      }
    }
  }
  
  
  $('#billing_address_vat').on("input", function () {
    const $vat_code = $('#billing_address_vat')
    // $vat_code.validator('validate')
    
    controllaCF($vat_code);
    
  })
  
  
  const check_insurance = (country, sender_country) => {
    
    if ((country === sender_country) || (isEUCountry(country) && isEUCountry(sender_country))) {
      $('#insured_shipment_input').show();
    } else {
      $('#insured_shipment_input').hide();
    }
  }
  const check_vat = (country) => {
    const $vat_code = $('#billing_address_vat')
    if (country === 'IT') {
      enable_vat();
      // $vat_code.validator('validate')
      controllaCF($('#billing_address_vat'));
    } else {
      reset_vat_icon($('#vat_code_icon'))
      disable_vat();
      remove_error_from_group($('#vat-group'))
      $('#cf-errors').text('');
      $(':input[type="submit"]').prop('disabled', false);
      
    }
  }
  
  const show_ide_pec_face = (country, location) => {
    if (country === 'IT') {
      enable_pec_face(location)
    } else {
      const hide_it = true;
      enable_pec_face(location, hide_it)
    }
    
  }
  
  const billing_address_required = (required_value) => {
    if (required_value) {
      $('.billing_address_el').prop('required', true);
    } else {
      $('.billing_address_el').removeAttr('required');
    }
  }
  
  const pec_face_for_ita = () => {
    if ($('#billing_address_use_it').prop('checked')) {
      $('#billing_address').addClass('in');
      check_vat($('#bill_pk_address_country_code').val());
      billing_address_required(true);
      show_ide_pec_face($('#bill_pk_address_country_code').val(),
        $('#bill_delivery_address_location_type').val())
    } else {
      $('#billing_address').removeClass('in');
      check_vat($('#pickup_address_country_code').val());
      billing_address_required(false);
      show_ide_pec_face($('#pickup_address_country_code').val(),
        $('#pickup_address_location_type').val())
    }
    
  }
  
  const check_pec_face = () => {
    if ($('#billing_address_use_it').prop('checked')) {
      pec_face_for_ita($('#bill_delivery_address_location_type').val())
      
    } else {
      pec_face_for_ita($('#pickup_address_location_type').val())
    }
    
    
  }
  const toggle_company = function (value, $company_address) {
    if (value === 'R') {
      $company_address.removeClass('show')
      $company_address.collapse('hide')
      $company_address.addClass('hide')
      $('.company-required-c').removeAttr('required')
      $('.company-required-b').removeAttr('required')
      $('.admin-validate').validator('destroy')
      
    } else if (value === 'B') {
      $company_address.removeClass('hide')
      $company_address.collapse('show')
      $('.company-required-c').removeAttr('required')
      $('.company-required-b').prop('required', true)
      $('.admin-validate').validator()
    }
    check_pec_face();
  }
  
  function toggle_admin_pickup_address(value) {
    if (value === 'customer') {
      $('#if-customer').show()
      $('#if-business').hide()
      $('.company-required-c').removeAttr('required')
      $('.company-required-b').removeAttr('required')
    } else {
      $('#if-customer').hide()
      $('#if-business').show()
      $('.company-required-b').prop('required', true)
      $('.company-required-c').removeAttr('required')
    }
  }
  
  function set_required_fields() {
    if ($('#user_role').val() === 'customer') {
      $('.company-required-c').removeAttr('required')
      $('.company-required-b').removeAttr('required')
    } else {
      $('.company-required-b').prop('required', true)
      $('.company-required-c').removeAttr('required')
    }
  }
  
  const initial_role$ = $('#initial_role').val();
  if (initial_role$ === 'location') {
    toggle_admin_pickup_address(initial_role$)
  } else {
    $('#admin-pickup-address').toggle(false)
    hide_pk_addr();
  }
  
  // $('#admin-pickup-address').collapse('hide');
  
  $('#show_hide_pk_address').click(() => show_hide_pickup_address())
  
  $('#pickup_address_location_type').change(function () {
    toggle_company($('#pickup_address_location_type').val(), $('#company-address'))
  })
  
  
  $('#user_role').change(function () {
    toggle_admin_pickup_address($('#user_role').val());
    
  });
  
  $('#billing_address_use_it').change(() => check_pec_face())
  
  $('.admin-validate').validator();
  
  const verify_address_location_type$ = $('#pickup_address_location_type');
  
  verify_address_location_type$.change(function (data) {
    toggle_company(verify_address_location_type$.val(), $('#company-address'))
  })
  
  
  $('#bill_delivery_address_location_type').change(function (data) {
    toggle_company($('#bill_delivery_address_location_type').val(), $('#bill-company-address'))
  })
  
  var toggle_delivery_info = function (value) {
    if (value === 'by_hand') {
      $('#choosen-courier').collapse('hide')
      $('#choosen-hand').collapse('show')
      $('.delivery-required').removeAttr('required')
      $('.validate-me').validator('destroy')
      toggle_company(verify_address_location_type$.val(), $('#company-address'))
    } else if (value === 'by_delivery_service') {
      $('#choosen-courier').collapse('show')
      $('#choosen-hand').collapse('hide')
      $('.delivery-required').prop('required', true)
      $('.validate-me').validator()
      toggle_company(verify_address_location_type$.val(), $('#company-address'))
    } else {
      $('#choosen-courier').collapse('hide')
      $('#choosen-hand').collapse('hide')
      $('.delivery-required').removeAttr('required')
      $('.validate-me').validator('destroy')
    }
    
  }
  
  $('#delivery_method_type').change(function () {
    toggle_delivery_info($('#delivery_method_type').val())
  })
  
  toggle_delivery_info($('#delivery_method_type').val())
  
  $('#pickup_address_country_code').change(function () {
    
    const country_code = $('#pickup_address_country_code').val();
    check_street_number(country_code);
    check_postal_code(country_code);
    check_vat(country_code);
    check_insurance(country_code);
    pec_face_for_ita(country_code)
  });
  $('#bill_pk_address_country_code').change(() => {
    const country_code = $('#bill_pk_address_country_code').val();
    
    pec_face_for_ita(country_code)
    check_vat(country_code);
  });
  
  $('#bill_delivery_address_location_type').change(() => {
    pec_face_for_ita($('#bill_delivery_address_location_type').val())
  });
  var $pickup_address_country_code = $('#pickup_address_country_code');
  if ($pickup_address_country_code.val() !== undefined) {
    check_vat($pickup_address_country_code.val())
    check_street_number($pickup_address_country_code.val());
    check_postal_code($pickup_address_country_code.val());
    check_insurance($pickup_address_country_code.val(),$('#sender_country').val());
    check_pec_face();
  }
  
  function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  
  // insured shipping animation
  const $insuredCheckbox = $('#insured_shipping');
  const $insuredField = $('#insured_value_field');
  
  // stato iniziale: se il server ha già messo la checkbox spuntata
  if ($insuredCheckbox.length > 0) {
    if ($insuredCheckbox.is(':checked')) {
      $insuredField.show();          // visibile senza animazione al load
    } else {
      $insuredField.hide();       // completamente nascosto
    }
  }
  
  $insuredCheckbox.on('change', function () {
    $insuredField.stop(true, true);  // ferma eventuali animazioni
    
    if ($(this).is(':checked')) {
      $insuredField.slideDown(250);  // mostra e spinge giù il resto
      updateInsuredValueState();     // Assicura lo stato corretto dell'input
    } else {
      $insuredField.slideUp(250);    // nasconde, il resto risale
      
      // Reset campi quando viene disabilitata l'assicurazione
      $confirmedCheckbox.prop('checked', false);
      $insuredValueInput.val('').prop('disabled', true).prop('required', false);
    }
  });

  const $confirmedCheckbox = $('#insured_shipping_confirmed');
  const $insuredValueInput = $('#insured_value');

  function updateInsuredValueState() {
    if ($confirmedCheckbox.length === 0) return;
    
    // Se l'assicurazione principale non è spuntata, l'input deve essere disabled e non required
    if (!$insuredCheckbox.is(':checked')) {
      $insuredValueInput.prop('disabled', true).prop('required', false);
      return;
    }

    // Se il server ha già disabilitato il checkbox (es. quotazione esistente), non tocchiamo nulla
    if ($confirmedCheckbox.prop('disabled')) return;

    if ($confirmedCheckbox.is(':checked')) {
      $insuredValueInput.prop('disabled', false).prop('required', true);
    } else {
      $insuredValueInput.prop('disabled', true).prop('required', false);
    }
  }

  // Stato iniziale al caricamento
  updateInsuredValueState();

  $confirmedCheckbox.on('change', function() {
    updateInsuredValueState();
    if (!$(this).is(':checked')) {
      $insuredValueInput.val('');
    }
  });
  
  document.activeElement.blur();
  setTimeout(topFunction, 1);
})
